import { useState } from 'react'
import type { FormEvent } from 'react'
import { Navigate, useLocation, useNavigate } from 'react-router-dom'
import { ErrorApi } from '../api/cliente'
import { useAuth } from '../auth/ContextoAuth'
import { AvisoConexion } from '../componentes/AvisoConexion'

export function Login() {
    const { usuario, cargando, entrar } = useAuth()
    const navegar = useNavigate()
    const ubicacion = useLocation()

    const [nombreUsuario, setNombreUsuario] = useState('')
    const [contrasena, setContrasena] = useState('')
    const [error, setError] = useState<string | null>(null)
    const [enviando, setEnviando] = useState(false)

    if (cargando) {
        return (
            <div className="fila centro" style={{ minHeight: '100dvh' }}>
                <span className="cargando" aria-label="Cargando" />
            </div>
        )
    }

    if (usuario) {
        const destino = (ubicacion.state as { destino?: string } | null)?.destino
        return <Navigate to={destino ?? '/pos'} replace />
    }

    async function enviar(evento: FormEvent) {
        evento.preventDefault()
        setError(null)
        setEnviando(true)

        try {
            await entrar(nombreUsuario.trim(), contrasena)

            const destino = (ubicacion.state as { destino?: string } | null)?.destino
            navegar(destino ?? '/pos', { replace: true })
        } catch (fallo) {
            setError(
                fallo instanceof ErrorApi
                    ? fallo.mensajeVisible()
                    : 'No se pudo conectar con el servidor. Revise la conexión.',
            )
            setContrasena('')
        } finally {
            setEnviando(false)
        }
    }

    return (
        <div className="pantalla-entrada">
            <form className="panel tarjeta-entrada columna g4" onSubmit={enviar}>
                <div className="columna g1">
                    <h1>Minimarket</h1>
                    <p className="tenue chico">Ingrese con su usuario para comenzar el turno.</p>
                </div>

                {/* Instalada, la aplicacion abre aunque no haya red, y lo primero
                    que se ve es esta pantalla: sin el aviso, el cajero escribe la
                    contrasena y recien ahi se entera. */}
                <AvisoConexion />

                {error && (
                    <p className="aviso aviso-error" role="alert">
                        {error}
                    </p>
                )}

                <div>
                    <label className="etiqueta" htmlFor="usuario">Usuario</label>
                    <input
                        id="usuario"
                        className="campo"
                        value={nombreUsuario}
                        onChange={(evento) => setNombreUsuario(evento.target.value)}
                        autoComplete="username"
                        autoCapitalize="none"
                        autoCorrect="off"
                        spellCheck={false}
                        required
                        autoFocus
                    />
                </div>

                <div>
                    <label className="etiqueta" htmlFor="contrasena">Contraseña</label>
                    <input
                        id="contrasena"
                        className="campo"
                        type="password"
                        value={contrasena}
                        onChange={(evento) => setContrasena(evento.target.value)}
                        autoComplete="current-password"
                        required
                    />
                </div>

                <button
                    type="submit"
                    className="boton boton-primario boton-grande boton-bloque"
                    disabled={enviando || nombreUsuario.trim() === '' || contrasena === ''}
                >
                    {enviando ? <span className="cargando" /> : 'Entrar'}
                </button>
            </form>
        </div>
    )
}
